define('view/disclosure/document.action.edit.view',['require','exports','module','blockit','uikit/uikit'],function(require, exports, module) {
    var BlocKit = require('blockit');
    var UIKit   = require('uikit/uikit');

    var DocumentActionEditView = UIKit.ItemView.extend({
            template: function() {
                return '<ui name="DocumentTypeTextView" /> <ui name="DocumentTypeDropdownView" />';
            },




        internalViewOptions: function() {

            var rowModel                       = this.getOption('model');
            var documentTypeCollection         = this.getOption('documentTypeCollection') || [];

            return {

                DocumentTypeTextView: {
                    type: UIKit.Text,
                    model: rowModel,
                    behaviors: {
                        visibleOnlyInEditMode: {
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                            optionValues: {
                                text:
                                    {
                                    formatter: function(rowModel) {
                                         return rowModel.get('type');
                                    },
                                },
                                visible: {
                                    formatter: function(rowModel) {
                                        return !rowModel.get('editMode');
                                    },
                                },
                            },
                        },
                    },
                },



                DocumentTypeDropdownView: {
                    type: UIKit.Dropdown,
                    placeholder: ' -- ',
                    rowModel: rowModel,
                    collection: documentTypeCollection,

                    search: true,
                    childBindings: {
                        text: 'value',
                    },
                     behaviors: {
                         visibleOnlyInEditMode: {
                             behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior.extend({
                                 onFirstBeforeRender: function() {

                                     this.determineSelectedDropdownValue();

                                     var dropdownView = this.view;
                                     this.listenTo(dropdownView, 'item:select', function(selectedView, selectedModel) {
                                         rowModel.set('type', selectedModel.get('value'));
                                     });

                                 },

                                 determineSelectedDropdownValue: function() {
                                     var currentModelValue = rowModel.get('type');

                                     if (currentModelValue == null) {
                                         return;
                                     }
                                     var selectedDropdownValue;
                                     this.view.collection.each(function(dropdownValueModel)
                                     {
                                         var bindingValueId = dropdownValueModel.get('value');

                                         if (currentModelValue === bindingValueId) {
                                             selectedDropdownValue = dropdownValueModel;
                                             return false; // break
                                         }
                                     });
                                     this.view.value = selectedDropdownValue;
                                 },

                             }),
                             optionValues: {
                                 visible: {
                                     model: rowModel,
                                     formatter: function() {
                                         return this.view.rowModel.get('editMode');
                                     },
                                 },
                             },
                         },
                     },
                },



            };
        },
    });

    module.exports = DocumentActionEditView;
});

